import LeverageSelector from '@/components/LeverageSelector';
import { TRADE_OVERLAY_TYPE } from '@/constants/trade';
import { useTradeStore } from '@/features/trade/store';
import { useTranslation } from 'react-i18next';
import IconChevronSelect12 from './assets/icon_chevron_select_12.svg?react';
import './index.less';

export default function TradeFormHeader() {
  const { t } = useTranslation();
  const { setShowTradeAreaOverlay } = useTradeStore();

  return (
    <div className="syn-trade-form-header">
      <div className="syn-trade-form-header-top">
        <div className="syn-trade-form-header-title">{t('common.trade')}</div>
        <div
          className="syn-trade-form-header-right"
          onClick={() => setShowTradeAreaOverlay(TRADE_OVERLAY_TYPE.ADD_LIQ)}>
          <span>{t('common.liquidity')}</span>
          <IconChevronSelect12 />
        </div>
      </div>
      <LeverageSelector />
    </div>
  );
}
